<!-- タイムシート画面から開く打刻修正ダイアログで使用 -->
<template>
  <template v-if="(isCreating) && !isResult">
    <loading :isLoading="isCreating" :message="'処理中...'"></loading>
  </template>
  <template v-if="(!isCreating) && !isResult">
    <div :class="{ error: dakokuDateError }">
      <p>{{ syuuseiData.before.dakoku_date }}の打刻情報を修正します。</p>
      <p class="input-error" v-if="dakokuDateError">{{ dakokuDateError }}</p>
    </div>
    <div class="form-item">
      <div class="before-after">
        <koyouKeiyakuTimeSelect :isequiredSyuugyouBasyo="false" :hideSyuugyouBasyo=true :isRequiredWorkTime=false :koyouKeiyakuId="koyouKeiyakuId" :workTimeId="syuuseiData.before.koyou_keiyaku_time_id" :targetDate="syuuseiData.before.dakoku_date" :koyouKeiyakuTimeId="syuuseiData.before.koyou_keiyaku_time_id"
          @change="changeKoyouKeiyakuTime">
        </koyouKeiyakuTimeSelect>
      </div>
    </div>
    <div class="form-item">
      <label>出勤</label>
      <div class="before-after">
        <p class="before">{{ syuuseiData.before.syukkin_datetime ? timeFormatter(syuuseiData.before.syukkin_datetime) :
          '記録なし' }}</p>
        <p class="arrow">→</p>
        <time-picker class="after" v-model="syuuseiData.after.syukkin_datetime" :startTime="{ hours: 0, minutes: 0 }"
          :error="getError(form.dakoku_syuusei, 'syukkin_datetime')"></time-picker>
      </div>
    </div>

    <div class="form-item">
      <label>退勤</label>
      <div class="before-after">
        <p class="before">{{ syuuseiData.before.taikin_datetime ? timeFormatter(syuuseiData.before.taikin_datetime) :
          '記録なし' }}</p>
        <p class="arrow">→</p>
        <time-picker class="after" v-model="syuuseiData.after.taikin_datetime" :startTime="{ hours: 0, minutes: 0 }"
          :error="getError(form.dakoku_syuusei, 'taikin_datetime')"></time-picker>
      </div>
    </div>

    <div class="form-item">
      <label>外出</label>
      <div class="before-after">
        <p class="before">{{ syuuseiData.before.gaisyutsu_datetime ? timeFormatter(syuuseiData.before.gaisyutsu_datetime)
          : '記録なし' }}</p>
        <p class="arrow">→</p>
        <time-picker class="after" v-model="syuuseiData.after.gaisyutsu_datetime" :startTime="{ hours: 0, minutes: 0 }"
          :error="getError(form.dakoku_syuusei, 'gaisyutsu_datetime')"></time-picker>
      </div>
    </div>

    <div class="form-item">
      <label>戻り</label>
      <div class="before-after">
        <p class="before">{{ syuuseiData.before.modori_datetime ? timeFormatter(syuuseiData.before.modori_datetime) :
          '記録なし' }}</p>
        <p class="arrow">→</p>
        <time-picker class="after" v-model="syuuseiData.after.modori_datetime" :startTime="{ hours: 0, minutes: 0 }"
          :error="getError(form.dakoku_syuusei, 'modori_datetime')"></time-picker>
      </div>
    </div>

    <div class="form-item">
      <label>休憩</label>
      <div class="before-after">
        <p class="before">{{ syuuseiData.before.kyuukei_times ? timeFormatter(syuuseiData.before.kyuukei_times) : '記録なし'
        }}</p>
        <p class="arrow">→</p>
        <time-picker class="after" v-model="syuuseiData.after.kyuukei_times" :startTime="{ hours: 0, minutes: 0 }"
          :minTime="{ hours: 0, minutes: 0, seconds: 0 }" :maxTime="{ hours: 2, minutes: 0, seconds: 0 }"
          :error="getError(form.dakoku_syuusei, 'kyuukei_times')">
        </time-picker>
      </div>
    </div>

    <div class="buttons button-select">
      <button type="button" class="btn success" @click="send()" :disabled="isLoadingKoyouKeiyakuTime"><i class="fa-solid fa-inbox"></i>申請</button>
      <button type="button" class="btn cancel" @click="cancel()"><i class="fa-solid fa-x"></i>閉じる</button>
    </div>
    <div class="buttons">
      <template v-if="syuuseiData.before.dakoku_id">
        <button type="button" class="btn danger" @click="torikeshi()" :disabled="isLoadingKoyouKeiyakuTime"><i class="fa-solid fa-inbox"></i>打刻取消</button>
      </template>
      <template v-if="hayabanOsobanData.hayaban_osoban_id">
        <button type="button" class="btn danger" @click="hayabanOsobanTorikeshi()" :disabled="isLoadingKoyouKeiyakuTime"><i
            class="fa-solid fa-clock"></i>早番遅番申請の取消</button>
      </template>
      <template v-if="koukyuuId">
        <button type="button" class="btn danger" @click="koukyuuTorikeshi(koukyuuId)" :disabled="isLoadingKoyouKeiyakuTime">
          <i class="fa-solid fa-house"></i>公休申請の取り消し</button>
      </template>
    </div>
  </template>
  <template v-if="!isCreating && isResult">
    <div class="form-item updated">
      <label>{{ resultMsg }}</label>
    </div>
    <div class="buttons">
      <button type="button" class="btn cancel" @click="close()"><i class="fa-solid fa-x"></i>閉じる</button>
    </div>
  </template>
</template>

<script lang="ts">
import { DakokuSyuuseiData } from '@/composable/modal/dakoku-syuusei';
import { DakokuInfoShinsei, ShinseiInfo } from '@/types/Dakoku';
import { computed, defineComponent, ref, Ref } from 'vue';
import { useInit } from '@/composable/shinsei/typelist/init';
import { useCreate } from '@/composable/shinsei/create';
import { timeFormat } from "@/filters/common";
import { DialogService } from '@/service/DialogService';
import OptionConst from "@/const/Option";
import { useForm } from '@/composable/form/form';
import { useInit as useDakokuInit } from '@/composable/shinsei/dakoku-syuusei/init';
import { useDelete as useHayabanOsobanDelete } from '@/composable/shinsei/hayaban_osoban/delete';
import { useDelete as useKoukyuuDelete } from '@/composable/shinsei/koukyuu/delete';
import { HayabanOsoban } from '@/types/Shinsei';
import { DateUtil } from '@/utils/DateUtil';
import { KoyouKeiyakuTimeAndHayabanOsobanOption } from '@/types/KoyouKeiyakuTime';
import KoyouKeiyakuTImeSelect from "@/components/shinsei/create/parts/KoyouKeiyakuTimeSelect.vue"
import Swal from 'sweetalert2';
import { KoyouKeiyakuTimeSelectEmitData } from '@/types/SyuugyouBasyo';
import { Logger } from '@/utils/Logger';

export default defineComponent({
  props: {
    syuuseiData: {
      type: Object as () => DakokuSyuuseiData,
      default: null
    },
    hayabanOsobanData: {
      type: Object as () => HayabanOsoban,
      default: null
    },
    shinseiData: {
      type: Object as () => DakokuInfoShinsei,
      default: null
    },
    koyouKeiyakuId: {
      type: Number as () => number | null,
      default: null
    },
    syuugyouBasyoId: {
      type: Number as () => number | null,
      default: null
    },
  },
  emits: {
    send: (result: boolean) => true,
    cancel: () => true,
    load: () => true,
  },
  setup(props, context) {
    const { form } = useInit()
    const { createForDakokuSyuusei, isCreating } = useCreate()
    const { hayabanOsobanDelete } = useHayabanOsobanDelete()
    const { koukyuuDelete } = useKoukyuuDelete()
    const isResult = ref(false)
    const { getError } = useForm()
    const resultMsg = ref('')
    useDakokuInit(form.value)
    
    // 早番遅番申請の取り消し時に選択する元々の就業時間一覧
    const koyouKeiyakuTimeOpt: Ref<KoyouKeiyakuTimeAndHayabanOsobanOption[]> = ref([])

    // 就業時間の読み込みフラグ
    // コンポーネント読み込み時のみ就業時間の取得を行うため実質初期化フラグ
    const isLoadingKoyouKeiyakuTime = ref(true)

    const send = async () => {
      DialogService.question({
        text: '打刻修正を申請しますか？',
        confirmButtonText: 'はい',
        showCancelButton: true,
        cancelButtonText: 'いいえ',
        preConfirm: () => {
          let shinseiData = setSendData(false);

          // 出勤、退勤、休憩が記録なしの場合
          if(
            (shinseiData.syukkin_datetime == "" || shinseiData.syukkin_datetime == null)
            ||
            (shinseiData.taikin_datetime == "" || shinseiData.taikin_datetime == null)
            ||
            (shinseiData.kyuukei_times == "" || shinseiData.kyuukei_times == null)
          ){
            return Swal.showValidationMessage('出勤、退勤、休憩は必須です');
          }

          // 出勤時間と退勤時間が同じ場合
          if (DateUtil.isSameTime(shinseiData.syukkin_datetime, shinseiData.taikin_datetime))
          {
            return Swal.showValidationMessage('出勤と退勤が同じ時間です');
          }

          // 外出時間と戻り時間がともに00:00の場合、入力なしにする
          if (shinseiData.gaisyutsu_datetime == '00:00:00' && shinseiData.modori_datetime == '00:00:00')
          {
            syuuseiData.value.after.gaisyutsu_datetime = '';
            syuuseiData.value.after.modori_datetime = '';
          } else if (DateUtil.isSameTime(shinseiData.gaisyutsu_datetime, shinseiData.modori_datetime))
          {
            return Swal.showValidationMessage('外出と戻りが同じ時間です');
          }

          return true;
        }
      }).then(async (result) => {
        if (!result.isConfirmed) {
          return
        }
        form.value.shinsei_type = OptionConst.SHINSEI_CODE.DAKOKU_SYUUSEI
        form.value.mst_syuugyou_basyo_id = props.syuugyouBasyoId
        form.value.dakoku_syuusei = setSendData(false)
        form.value.koyou_keiyaku_id = props.koyouKeiyakuId
        form.value.mst_syuugyou_basyo_id = props.syuugyouBasyoId
        await createForDakokuSyuusei(form).then(res => {
          isResult.value = res ? true : false
          resultMsg.value = '申請しました'
        })
      })
    }

    const isWaitOrApproved = (v: ShinseiInfo) => (
      v.syounin_status_type === OptionConst.SYOUNIN_STATUS.WAIT || v.syounin_status_type === OptionConst.SYOUNIN_STATUS.APPROVED
    )
    const torikeshi = async () => {
      DialogService.question({
        text: '打刻取消を申請しますか？',
        confirmButtonText: 'はい',
        showCancelButton: true,
        cancelButtonText: 'いいえ',
        preConfirm: () => {
          // 申請データに「承認待ち」や「承認済み」が存在する場合
          if (
            props.shinseiData.hayabanOsoban.some(isWaitOrApproved) || props.shinseiData.koukyuu.some(isWaitOrApproved) ||
            props.shinseiData.jikangai.some(isWaitOrApproved) || props.shinseiData.kyuukei.some(isWaitOrApproved) ||
            props.shinseiData.furikyuu.some(isWaitOrApproved) || props.shinseiData.yuukyuu.some(isWaitOrApproved) ||
            props.shinseiData.kekkin.some(isWaitOrApproved) || props.shinseiData.soutai.some(isWaitOrApproved) ||
            props.shinseiData.chikoku.some(isWaitOrApproved) || props.shinseiData.nittyoku.some(isWaitOrApproved) ||
            props.shinseiData.kibiki.some(isWaitOrApproved)
          ) {
            return Swal.showValidationMessage('未承認の申請、承認された申請が残っています。（異動届を除く）承認者が打刻取消する日の申請をすべて取消した後、打刻取消を行えます。');
          }

          return true;
        }
      }).then(async (result) => {
        if (!result.isConfirmed) {
          return
        }
        form.value.shinsei_type = OptionConst.SHINSEI_CODE.DAKOKU_SYUUSEI
        form.value.mst_syuugyou_basyo_id = props.syuugyouBasyoId
        form.value.dakoku_syuusei = setSendData(true)
        form.value.koyou_keiyaku_id = props.koyouKeiyakuId
        form.value.mst_syuugyou_basyo_id = props.syuugyouBasyoId
        await createForDakokuSyuusei(form).then(res => {
          isResult.value = res ? true : false
          resultMsg.value = '申請しました'
        })
      })
    }

    const hayabanOsobanTorikeshi = async () => {
      if(!form.value.dakoku_syuusei) return
      let options:{[val:number]: string} = {}
      Logger.debug('就業時間', koyouKeiyakuTimeOpt.value)
      for(const v of koyouKeiyakuTimeOpt.value){
        if(!v.val || !v.label){ continue }
        options[v.val] = v.label
      }
      Logger.debug('就業時間（オプション値）', options)
      const hayabanOsoban = props.hayabanOsobanData
      const start = hayabanOsoban.start_datetime ? DateUtil.format(hayabanOsoban.start_datetime, 'HH:mm') : null
      const end = hayabanOsoban.end_datetime ? DateUtil.format(hayabanOsoban.end_datetime, 'HH:mm') : null
      const MsgHtml = [
        '<p>この内容の申請を取り消します。よろしいですか？</P>'
        , '<br><div class="aligncenter">'
        , '<p>開始時間　' + start + '</p>'
        , '<p>終了時間　' + end + '</p></div>'
      ]
      DialogService.question({
        title: '早番遅番申請の取消',
        html: MsgHtml.join(''),
        customClass: 'shift-del-alert',
        confirmButtonText: 'はい',
        showCancelButton: true,
        cancelButtonText: 'いいえ',
        input: 'select',
        inputOptions: options,
        inputPlaceholder: '変更後の就業時間を選択してください（必須）',
        preConfirm: () => {
          const value = Swal.getInput()?.value
          if(!value){
            return Swal.showValidationMessage('就業時間は必須選択です')
          }
          return value
        }
      }).then(async (result) => {
        if (!result.isConfirmed) {
          return
        }

        isCreating.value = true
        await hayabanOsobanDelete(hayabanOsoban, result.value).then(res => {
          isResult.value = res ? true : false
          if (res) {
            isResult.value = true
            resultMsg.value = '早番遅番申請を取り消しました'
            context.emit('load');
          } else {
            isResult.value = false
            resultMsg.value = '早番遅番申請の取り消しに失敗しました'
          }
        })
        isCreating.value = false
      })
    }

    const koukyuuTorikeshi = (koukyuuId: number | null) => {
      if(!koukyuuId){
        DialogService.error({
          title: '打刻IDの取得失敗',
          text: '公休申請の取り消しに失敗しました',
        });
        return
      }
      DialogService.question({
        title: '公休申請の取消',
        html: '申請を取り消しますか？',
        showCancelButton: true,
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
      }).then(async (result) => {
        if (!result.isConfirmed) {
          return
        }
        isCreating.value = true
        await koukyuuDelete(koukyuuId).then(res => {
          isResult.value = res ? true : false
          if (res) {
            isResult.value = true
            resultMsg.value = '公休申請を取り消しました'
            context.emit('load');
          } else {
            isResult.value = false
            resultMsg.value = '公休申請の取り消しに失敗しました'
          }
        })
        isCreating.value = false
      })
    }

    const cancel = () => {
      context.emit('cancel');
    }

    const close = () => {
      context.emit('send', isResult.value);
    }

    const syuuseiData = computed(() => {
      return props.syuuseiData
    })

    const koukyuuId = computed(() => {
      const activeKoukyuu = props.shinseiData.koukyuu.find((koukyuu)=>{
        return koukyuu.syounin_status_type != OptionConst.SYOUNIN_STATUS.CANCEL
      })
      return activeKoukyuu != null ? activeKoukyuu.id : null
    })

    const timeFormatter = (time: string): string => {
      return timeFormat(props.syuuseiData.after.dakoku_date + ' ' + time)
    }

    const dakokuDateError = computed(() => {
      return getError(form.value.dakoku_syuusei, 'dakoku_date')
    })

    const setSendData = (isTorikeshi: boolean = false) => {
      return {
        dakoku_date: syuuseiData.value.after.dakoku_date,
        koyou_keiyaku_time_id: syuuseiData.value.after.koyou_keiyaku_time_id,
        is_torikeshi: isTorikeshi,
        dakoku_id: syuuseiData.value.after.dakoku_id,
        gaisyutsu_datetime: syuuseiData.value.after.gaisyutsu_datetime,
        kyuukei_times: syuuseiData.value.after.kyuukei_times,
        modori_datetime: syuuseiData.value.after.modori_datetime,
        syukkin_datetime: syuuseiData.value.after.syukkin_datetime,
        taikin_datetime: syuuseiData.value.after.taikin_datetime,
        before_gaisyutsu_datetime: syuuseiData.value.before.gaisyutsu_datetime,
        before_kyuukei_times: syuuseiData.value.before.kyuukei_times,
        before_modori_datetime: syuuseiData.value.before.modori_datetime,
        before_syukkin_datetime: syuuseiData.value.before.syukkin_datetime,
        before_taikin_datetime: syuuseiData.value.before.taikin_datetime,
      }
    }

    const changeKoyouKeiyakuTime = (emitData: KoyouKeiyakuTimeSelectEmitData) => {
      isLoadingKoyouKeiyakuTime.value = true
      if(emitData.targetDate && emitData.selectedKoyouKeiyakuTimeOption){
        syuuseiData.value.after.koyou_keiyaku_time_id = emitData.selectedKoyouKeiyakuTimeOption.val
        form.value.shinsei_koyou_keiyaku_time = [{
          shinsei_id: form.value.shinsei_id,
          koyou_keiyaku_time_id: emitData.selectedKoyouKeiyakuTimeOption.val,
          target_date: emitData.targetDate,
          tsuujouTime: null,
          isHannichi: null,
          canOnlyAmKinmu: null,
          canOnlyPmKinmu: null,
        }]
      }else{
        syuuseiData.value.after.koyou_keiyaku_time_id = null
        form.value.shinsei_koyou_keiyaku_time = []
      }

      // 早番遅番の取消時に選択する元々の就業時間一覧をセット
      koyouKeiyakuTimeOpt.value = emitData.koyouKeiyakuTimeAndHayabanOsobanOptions.koyouKeiyakuTimeOpt
            
      isLoadingKoyouKeiyakuTime.value = false
    }

    return {
      send,
      cancel,
      close,
      torikeshi,
      timeFormatter,
      syuuseiData,
      isCreating,
      isResult,
      getError,
      form,
      dakokuDateError,
      hayabanOsobanTorikeshi,
      koukyuuId,
      koukyuuTorikeshi,
      resultMsg,
      OptionConst,
      changeKoyouKeiyakuTime,
      isLoadingKoyouKeiyakuTime,
    }
  },
  components: {
    'koyouKeiyakuTimeSelect': KoyouKeiyakuTImeSelect
  },
})
</script>

<style lang="scss" scoped>@import '@scss/dialog/dakoku-syuusei.scss';</style>
